import { IconsProps } from '@/types/shared'

const DashboardIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19 5.5V7.5H15V5.5H19ZM9 5.5V11.5H5V5.5H9ZM19 13.5V19.5H15V13.5H19ZM9 17.5V19.5H5V17.5H9ZM21 3.5H13V9.5H21V3.5ZM11 3.5H3V13.5H11V3.5ZM21 11.5H13V21.5H21V11.5ZM11 15.5H3V21.5H11V15.5Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default DashboardIcons
